import { useState } from "react";
import { getCustomerChat, InsertMandetoryQue } from "../../../Services/chatbot";
import { OverlayTrigger, Tooltip } from "../../../../evo/bootstrap";
import teachicon from "../../../assets/teachme.png";
import QnAModal from "../../QnAModal";
import { toast } from "react-toastify";
import BookingHistory from "../../BookingHistory";
import { hasBookingHistory, countBookingIntentTriggered } from "../../../utils/bookingHistoryUtils";

const AllChatHistory = ({ tabType, chatData, loading, formatTimeAgo, setIsDirty, isDirty, setPublishModal }: any) => {
  const [openConversation, setOpenConversation] = useState<any>(null);
  const [expandedConversations, setExpandedConversations] = useState<any>({});
  const [loadingRows, setLoadingRows] = useState<any>({});
  const [customerChats, setCustomerChats] = useState<any>({});
  const [newQuestionDraft, setNewQuestionDraft] = useState<any>({
    question: '', answer: '', intentID: '', order_id: '', propertyID: '', type: ''
  });
  const [showQnaModal, setShowQnaModal] = useState(false);
  const [qnaError, setQnaError] = useState("");
  const [modalLoading, setModalLoading] = useState(false);
  const [expandedItems, setExpandedItems] = useState<any>({});
  const [activeTab, setActiveTab] = useState<any>({}); // Track active tab per conversation: { key: 'chat' | 'booking' }



  const handleRowClick = async (conversationId, thread, index) => {
    // Handle inquiry data where conversation_id is empty and thread_id is 0
    const hasValidConversationId = conversationId && conversationId !== "";
    const hasValidThreadId = thread?.thread_id !== undefined && thread?.thread_id !== null && thread?.thread_id !== 0;
    const hasConversation = hasValidConversationId && hasValidThreadId;
    // Generate consistent key - for inquiry data (thread_id=0), use index to ensure uniqueness
    const threadId = (hasValidThreadId && hasValidConversationId) ? thread.thread_id : index;
    const key = hasConversation
      ? `${conversationId}_${thread.thread_id}`
      : `legacy_${threadId}`;

    // Toggle expand/collapse
    setOpenConversation((prev) => (prev === key ? null : key));

    // 🟠 Skip API if no conversation
    if (!hasConversation) return;

    // 🟢 Skip if already loaded
    if (customerChats[key]) return;

    // ✅ Set specific row to loading
    setLoadingRows((prev) => ({ ...prev, [key]: true }));

    try {
      const res = await getCustomerChat(conversationId, thread.thread_id);
      setCustomerChats((prev) => ({
        ...prev,
        [key]: res.data?.records || [],
      }));
    } catch (error) {
      console.error("❌ Failed to load customer chat:", error);
      toast.error("Failed to load conversation details");
    } finally {
      // ✅ Clear loading for this specific row
      setLoadingRows((prev) => ({ ...prev, [key]: false }));
    }
  };

  const getTooltipMessage = (action, item) => {
    if (action === "teach") {
      return "Teach me";
    }
    return "";
  };

  const handleAddFaq = (item) => {
    setNewQuestionDraft({
      question: item.question,
      answer: '',
      intentID: '',
      order_id: '',
      type: 'QnA'
    });
    setShowQnaModal(true);
  };

  const handleFAQSave = async () => {
    setModalLoading(true);
    const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "");
    const uniqueIntentID = `Q${timestamp}`;
    const orderId = Math.floor(Math.random() * 10000).toString();

    const payload = {
      ...newQuestionDraft,
      type: "QnA",
      intentID: uniqueIntentID,
      order_id: orderId
    };

    try {
      const res = await InsertMandetoryQue(payload);
      if (res.status === 200) {
        toast.success(res.data.message);
        setShowQnaModal(false);
        setModalLoading(false);
        setIsDirty(false)

      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      if (error.status === 401) {
        toast.error("Access denied. Please verify using a valid link.");
      }
      console.error("Failed to save question:", error);
      toast.error("Error saving question.");
    } finally {
      setModalLoading(false);
    }
  };
  const maskEmail = (email) => {
    if (!email || email === "No email provided") {
      return "No email provided";
    }
    const parts = email.split("@");
    if (parts.length === 2) {
      return `${parts[0]}@*****`;
    }
    return email; // Return as-is if not a valid email format
  };

  const truncateText = (text, length = 100) => {
    if (!text) return "";
    if (text.length > length) {
      return (
        <>
          {text.slice(0, length)}
          <span className="text-muted fw-medium ms-1" style={{ cursor: "pointer" }}>...see more</span>
        </>
      );
    }
    return text;
  };
  const toggleExpand = (key, field) => {
    setExpandedItems((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: !prev[key]?.[field],
      },
    }));
  };

  return (
    <>
      <div className="question-div mt-3">
        {chatData.length === 0 && !loading ? (
          <div className="text-center py-5">
            <p className="text-muted">No chats found.</p>
          </div>
        ) : (
          chatData.map((conversation, convIndex) => {
            const customerInfo = conversation.customer_info || {
              name:
                conversation.name ||
                (conversation.type === "inquiry"
                  ? conversation.question
                  : conversation.type === "anonymous"
                    ? `Guest user ${conversation.conversation_id?.split("-").pop() || ""}`
                    : "Past Message"),
              email: conversation.email || "No email provided",
              latest_chat_time: conversation.latest_chat_time || conversation.msg_time,
            };

            const threads =
              Array.isArray(conversation.threads) && conversation.threads.length > 0
                ? conversation.threads
                : [
                  {
                    ...conversation,
                    thread_id: conversation.thread_id || `legacy-${convIndex}`,
                    name: conversation.name || customerInfo.name,
                    email: conversation.email || customerInfo.email,
                    latest_chat_time: conversation.latest_chat_time || conversation.msg_time,
                    total_chats: conversation.total_chats || 1,
                    // Explicitly include question and answer for inquiry type data
                    question: conversation.question || conversation.threads?.[0]?.question,
                    answer: conversation.answer || conversation.threads?.[0]?.answer,
                    confidence: conversation.confidence || conversation.threads?.[0]?.confidence,
                    status_type: conversation.status_type || conversation.threads?.[0]?.status_type,
                  },
                ];

            const primaryEmail = maskEmail(customerInfo.email);
            const latestTime = customerInfo.latest_chat_time || threads[0]?.latest_chat_time;
            const conversationKey = conversation.conversation_id || `conversation_${convIndex}`;
            const isConversationExpanded = expandedConversations[conversationKey];

            return (
              <div key={conversationKey} className="mb-2">
                <div className="question-box">
                  <div
                    className="d-flex justify-content-between align-items-center custInfo"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setExpandedConversations((prev) => {
                        const isCurrentlyExpanded = prev[conversationKey];
                        // If clicking on an already expanded conversation, close it
                        if (isCurrentlyExpanded) {
                          return {
                            ...prev,
                            [conversationKey]: false,
                          };
                        }
                        // If clicking on a collapsed conversation, close all others and open this one
                        return {
                          [conversationKey]: true,
                        };
                      });
                    }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div className="new-chat-user-icon">
                        <i className="bi bi-person"></i>
                      </div>
                      <div className="d-flex flex-column gap-2 flex-wrap">
                        <div className="d-flex align-items-center gap-3">
                          <h6 className="mb-0 fw-semibold text-capitalize">
                            {customerInfo.name
                              ? customerInfo.name
                              : conversation.type === "anonymous"
                                ? `Guest user ${conversation.conversation_id?.split("-").pop()}`
                                : conversation.type === "inquiry"
                                  ? conversation.question
                                  : ""}
                          </h6>
                          {/* {convIndex === 0 && (
                            <span className="badge bg-primary-subtle text-primary fw-semibold px-2">
                              Latest
                            </span>
                          )} */}
                        </div>
                        <div className="d-flex align-items-center flex-wrap gap-2">
                          <span className="box-text text-muted"><i className="bi bi-envelope me-1"></i>{primaryEmail}</span>
                          {latestTime && (
                            <span className="box-text text-muted"><i className="bi bi-clock me-1"></i>{formatTimeAgo(latestTime)}</span>
                          )}
                        </div>
                      </div>
                    </div>
                    <i className={`bi ${isConversationExpanded ? "bi-chevron-up" : "bi-chevron-down"} text-muted`}></i>
                  </div>

                  {isConversationExpanded && (
                    <>
                      {threads.length > 0 ? (
                        <>
                          <h6 className="mt-4 mb-3 small text-muted">
                            All Customers in Group ({threads.length})
                          </h6>
                          <div className="group">
                            {threads.map((thread, threadIndex) => {
                              // Handle thread_id === 0 case for inquiry data (0 is falsy but valid)
                              // For inquiry data, thread_id is 0, so we need to check if conversation_id exists
                              const hasValidConversationId = conversation.conversation_id && conversation.conversation_id !== "";
                              const hasValidThreadId = thread.thread_id !== undefined && thread.thread_id !== null && thread.thread_id !== 0;
                              const hasConversation = hasValidConversationId && hasValidThreadId;
                              // Generate consistent key - for inquiry data (thread_id=0), use threadIndex to ensure uniqueness
                              const threadId = (hasValidThreadId && hasValidConversationId) ? thread.thread_id : threadIndex;
                              const key = hasConversation
                                ? `${conversation.conversation_id}_${thread.thread_id}`
                                : `legacy_${threadId}`;
                              const isExpanded = openConversation === key;
                              const chats = customerChats[key] || [];

                              return (
                                <>
                                  <div
                                    key={key}
                                    className={`d-flex justify-content-between align-items-center group-box flex-column ${isExpanded ? "show" : ""}`}
                                    style={{ cursor: "pointer" }}
                                    onClick={
                                      () => handleRowClick(conversation.conversation_id, thread, threadIndex)
                                    }
                                  >
                                    <div className="w-100 d-flex justify-content-between">
                                      <div className="d-flex align-items-center gap-3">
                                        <div className="new-chat-user-icon small">
                                          <i className="bi bi-person"></i>
                                        </div>
                                        <div className="d-flex flex-column">
                                          <h6 className="mb-1 fw-semibold text-capitalize">
                                            {thread.name
                                              ? thread.name
                                              : conversation.type === "anonymous"
                                                ? `Guest user ${conversation.conversation_id?.split("-").pop()}`
                                                : conversation.type === "inquiry"
                                                  ? thread.question
                                                  : ""}
                                          </h6>
                                          <div className="d-flex align-items-center flex-wrap column-gap-2 row-gap-1 small text-muted">
                                            <span><i className="bi bi-envelope me-1"></i>{maskEmail(thread.email)}</span>
                                            {/* <span><i className="bi bi-chat-left me-1"></i>{thread.total_chats || 0} chat{(thread.total_chats || 0) === 1 ? "" : "s"}</span> */}
                                            {thread.latest_chat_time && (
                                              <span><i className="bi bi-clock me-1"></i>{formatTimeAgo(thread.latest_chat_time)}</span>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <i className={`bi ${isExpanded ? "bi-chevron-up" : "bi-chevron-down"} text-muted`}></i>
                                    </div>
                                    {isExpanded && (
                                      <>
                                        {(() => {
                                          // Check if this conversation has booking history
                                          const hasBooking = chats.some(hasBookingHistory);
                                          const hasChatMessages = chats.some(chat => chat.question || chat.answer);
                                          const currentTab = activeTab[key] || (hasBooking && !hasChatMessages ? 'booking' : 'chat');
                                          
                                          // Count booking attempts
                                          const bookingRecords = chats.filter(hasBookingHistory);
                                          const chatMessages = chats.filter(chat => chat.question || chat.answer);
                                          
                                          return (
                                            <div className="w-100 mt-3">
                                              {/* Tabs - Show only if both chat and booking exist */}
                                              {(hasBooking && hasChatMessages) && (
                                                <div className="booking-chat-tabs mb-3">
                                                  <button
                                                    type="button"
                                                    className={`tab-btn ${currentTab === 'chat' ? 'active' : ''}`}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      setActiveTab(prev => ({ ...prev, [key]: 'chat' }));
                                                    }}
                                                  >
                                                    <i className="bi bi-chat-left me-1"></i>
                                                    Chat History
                                                    {/* {chatMessages.length > 0 && `(${chatMessages.length})`} */}
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className={`tab-btn ${currentTab === 'booking' ? 'active' : ''}`}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      setActiveTab(prev => ({ ...prev, [key]: 'booking' }));
                                                    }}
                                                  >
                                                    <i className="bi bi-calendar3 me-1"></i>
                                                    Booking History 
                                                    {/* {bookingRecords.length > 0 && `(${bookingRecords.length})`} */}
                                                  </button>
                                                </div>
                                              )}
                                              
                                              {/* Content based on active tab */}
                                              {currentTab === 'booking' && hasBooking ? (
                                                <div onClick={(e) => e.stopPropagation()}>
                                                  <BookingHistory records={chats} formatTimeAgo={formatTimeAgo} />
                                                </div>
                                              ) : (
                                                <>
                                                  {!hasConversation ? (
                                                    <div className="question-box box d-flex justify-content-between w-100">
                                            <div className="d-flex justify-content-between align-items-start w-100">

                                              {/* Left text content */}
                                              <div className="details flex-grow-1 d-flex flex-column">
                                                <div className="mb-2 d-flex align-items-center gap-2 flex-wrap">
                                                  <div className="d-flex align-items-center gap-1">
                                                    <span className="text-muted small fw-medium">AI Score:</span>
                                                    <i
                                                      className={`bi ${(thread.confidence?.toLowerCase() || "high") === "high"
                                                        ? "bi-hand-thumbs-up-fill"
                                                        : "bi-hand-thumbs-down-fill"
                                                        }`}
                                                      style={{
                                                        color:
                                                          (thread.confidence?.toLowerCase() || "high") === "high"
                                                            ? "#6ac86a"
                                                            : (thread.confidence?.toLowerCase() || "high") === "medium"
                                                              ? "#FFD700"
                                                              : "#ff5c70",
                                                        fontSize: "12px"
                                                      }}
                                                    ></i>
                                                  </div>
                                                  <div className="d-flex align-items-center gap-1">
                                                    <span className="text-muted small fw-medium">Status:</span>
                                                    <i
                                                      className={`bi ${thread.status_type === "success"
                                                        ? "bi-hand-thumbs-up-fill"
                                                        : "bi-hand-thumbs-down-fill"
                                                        }`}
                                                      style={{
                                                        color: thread.status_type === "success" ? "#6ac86a" : "#ff5c70",
                                                        fontSize: "12px"
                                                      }}
                                                    ></i>
                                                  </div>
                                                  {thread.latest_chat_time && (
                                                    <p className="small text-muted mb-0">
                                                      {new Date(thread.latest_chat_time).toLocaleString()}
                                                    </p>
                                                  )}
                                                </div>

                                                {/* Question */}
                                                <p
                                                  className="mb-2 fw-semibold small"
                                                  style={{ cursor: thread.question?.length > 100 ? "pointer" : "default" }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (thread.question?.length > 100) {
                                                      toggleExpand(`${key}_${threadIndex}`, "question");
                                                    }
                                                  }}
                                                >
                                                  {expandedItems[`${key}_${threadIndex}`]?.question
                                                    ? thread.question
                                                    : truncateText(thread.question, 100)}
                                                </p>

                                                {/* Answer */}
                                                <p
                                                  className="mb-0 text-muted small"
                                                  style={{ cursor: thread.answer?.length > 100 ? "pointer" : "default" }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (thread.answer?.length > 100) {
                                                      toggleExpand(`${key}_${threadIndex}`, "answer");
                                                    }
                                                  }}
                                                >
                                                  {expandedItems[`${key}_${threadIndex}`]?.answer
                                                    ? thread.answer
                                                    : truncateText(thread.answer, 100)}
                                                </p>
                                              </div>

                                              {/* Right — Teach Me Icon */}
                                              <div className="ms-3">
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip id={`tooltip-legacy-${threadIndex}`}>
                                                      {getTooltipMessage("teach", thread)}
                                                    </Tooltip>
                                                  }
                                                >
                                                  <img
                                                    src={teachicon}
                                                    alt="Teach me"
                                                    className="action-icon"
                                                    style={{ cursor: "pointer", width: "27px", height: "27px" }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleAddFaq(thread);
                                                    }}
                                                  />
                                                </OverlayTrigger>
                                              </div>

                                            </div>
                                          </div>
                                        ) : loadingRows[key] ? (
                                          <div className="text-center py-3">
                                            <div
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                            >
                                              <span className="visually-hidden">
                                                Loading...
                                              </span>
                                            </div>
                                          </div>
                                        ) : chats.length > 0 ? (
                                          chats
                                            .filter(chat => !hasBookingHistory(chat)) // Filter out booking records when showing chat
                                            .map((chat, idx) => {
                                            const confidence = (chat.confidence?.toLowerCase() || "high");
                                            const confidenceClass =
                                              confidence === "high"
                                                ? "text-success"
                                                : confidence === "medium"
                                                  ? "text-warning"
                                                  : "text-danger";

                                            return (
                                              <div key={idx} className="question-box box d-flex justify-content-between w-100">
                                                <div className="d-flex justify-content-between align-items-start flex-column">
                                                  <div className="flex-grow-1">
                                                    <div className="mb-2 d-flex align-items-center gap-2 flex-wrap">
                                                      <div className="d-flex align-items-center gap-1">
                                                        <span className="text-muted small fw-medium">AI Score:</span>
                                                        <i
                                                          className={`bi ${(chat.confidence?.toLowerCase() || "high") === "high"
                                                            ? "bi-hand-thumbs-up-fill"
                                                            : "bi-hand-thumbs-down-fill"
                                                            }`}
                                                          style={{
                                                            color:
                                                              (chat.confidence?.toLowerCase() || "high") === "high"
                                                                ? "#6ac86a"
                                                                : (chat.confidence?.toLowerCase() || "high") === "medium"
                                                                  ? "#FFD700"
                                                                  : "#ff5c70",
                                                            fontSize: "12px"
                                                          }}
                                                        ></i>
                                                      </div>
                                                      <div className="d-flex align-items-center gap-1">
                                                        <span className="text-muted small fw-medium">Status:</span>
                                                        <i
                                                          className={`bi ${chat.status_type === "success"
                                                            ? "bi-hand-thumbs-up-fill"
                                                            : "bi-hand-thumbs-down-fill"
                                                            }`}
                                                          style={{
                                                            color: chat.status_type === "success" ? "#6ac86a" : "#ff5c70",
                                                            fontSize: "12px"
                                                          }}
                                                        ></i>
                                                      </div>
                                                      <p className="small text-muted mb-0">
                                                        {new Date(
                                                          chat.msg_time
                                                        ).toLocaleString()}
                                                      </p>
                                                    </div>
                                                  </div>
                                                  <p
                                                    className="mb-2 fw-semibold small"
                                                    style={{ cursor: chat.question?.length > 100 ? "pointer" : "default" }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      if (chat.question?.length > 100) {
                                                        toggleExpand(`${key}_${idx}`, "question");
                                                      }
                                                    }}
                                                  >
                                                    {expandedItems[`${key}_${idx}`]?.question
                                                      ? chat.question
                                                      : truncateText(chat.question, 100)}
                                                  </p>
                                                  <p
                                                    className="mb-0 text-muted small"
                                                    style={{ cursor: chat.answer?.length > 100 ? "pointer" : "default" }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      if (chat.answer?.length > 100) {
                                                        toggleExpand(`${key}_${idx}`, "answer");
                                                      }
                                                    }}
                                                  >
                                                    {expandedItems[`${key}_${idx}`]?.answer
                                                      ? chat.answer
                                                      : truncateText(chat.answer, 100)}
                                                  </p>
                                                </div>
                                                <div className="ms-3">
                                                  <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                      <Tooltip id={`tooltip-${idx}`}>
                                                        {getTooltipMessage("teach", chat)}
                                                      </Tooltip>
                                                    }
                                                  >
                                                    <img
                                                      src={teachicon}
                                                      alt="Teach me"
                                                      className="action-icon"
                                                      style={{ cursor: "pointer", width: "27px", height: "27px" }}
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleAddFaq(chat);
                                                      }}
                                                    />
                                                  </OverlayTrigger>
                                                </div>

                                              </div>
                                            );
                                          })
                                        ) : (
                                          <p className="text-center text-muted py-3">
                                            {currentTab === 'booking' ? (() => {
                                              const bookingIntentCount = countBookingIntentTriggered(chats);
                                              if (bookingIntentCount > 0) {
                                                return `Booking was initiated ${bookingIntentCount} ${bookingIntentCount === 1 ? 'time' : 'times'}.`;
                                              }
                                              return 'No booking history found.';
                                            })() : 'No messages found'}
                                          </p>
                                        )}
                                                  </>
                                                )}
                                              </div>
                                            );
                                          })()}
                                      </>
                                    )}
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        </>
                      ) : (
                        <div className="question-box box bg-light border mt-3">
                          <p className="text-muted small mb-0">No participant threads found.</p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
      <QnAModal
        setIsDirty={setIsDirty}
        show={showQnaModal}
        onHide={() => {
          setQnaError("");
          setShowQnaModal(false);
          setIsDirty(false);
        }}
        mode="add"
        draft={newQuestionDraft}
        setDraft={setNewQuestionDraft}
        onSubmit={handleFAQSave}
        errorMsg={qnaError}
        setErrorMsg={setQnaError}
        loading={modalLoading}
        isDirty={isDirty}
        setPublishModal={setPublishModal}
      />
    </>
  );
};

export default AllChatHistory;
